import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import itemsPostData from "../data/itemsPostData";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import bg01 from "../assets/imgs/blog/post06.webp";
import bg02 from "../assets/imgs/blog/post02.jpg";
import bg03 from "../assets/imgs/blog/post03.jpg";

export function PostDetailPage() {
  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
    };
    scrollToTop();
  });

  const { id } = useParams();
  const post = itemsPostData.find((p) => p.id.toString() === id); // busca el post
  const { t } = useTranslation();

  if (!post) {
    return <h2>Post no encontrado</h2>;
  }

  return (
    <section className="wrapper_page_blog single wrapper__page_services">
      <div className="contain__head_page">
        <div className="container-lg">
          <div className="row g-5 justify-content-center">
            <div className="box_picture_post">
              <img
                className="trans"
                src={post.picture}
                alt={t("Organización de Congresos")}
              />
            </div>
            <div className="col-md-8">
              <p className="category_destacado text-center">
                <span className="trans">{post.category}</span>
              </p>
              <div className="d-block text-center">
                <h1 className="ttls c_morado mb-2 fw_700">{post.title}</h1>
              </div>
              <p className="paragraph lg fw_600 c_marin text-center">
                {post.subtitle}
              </p>
              <div className="content_extract text-center">
                <p className="paragraph lg">{post.extract}</p>
              </div>
            </div>
          </div>

          <div className="row g-5 justify-content-between mt-2">
            <div className="col-md-8">
              <div className="content_post_detail paragraph lg">
                <div
                  className="pt0"
                  dangerouslySetInnerHTML={{ __html: post.pt0 }}
                />
                <div
                  className="pt1 mt-5"
                  dangerouslySetInnerHTML={{ __html: post.pt1 }}
                ></div>
                <div>
                  <img
                    className="img__post_content"
                    src={post.pt1_img}
                    alt=""
                  />
                </div>
                <div
                  className="pt2 mt-5"
                  dangerouslySetInnerHTML={{ __html: post.pt2 }}
                ></div>
                <div>
                  <img
                    className="img__post_content"
                    src={post.pt2_img}
                    alt=""
                  />
                </div>
                <div
                  className="pt3 mt-5"
                  dangerouslySetInnerHTML={{ __html: post.pt3 }}
                ></div>
                <div>
                  <img
                    className="img__post_content"
                    src={post.pt3_img}
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <aside className="aside_post">
                <h4 className="fw_600 c_marin">¡Te puede interesar!</h4>
                <Link
                  to={"/blog/1/organizacion-de-congresos"}
                  className="item_picture"
                >
                  <img
                    src={bg01}
                    alt="Organización de congresos: planea, produce y ejecuta tu
                      evento con expertos"
                  />
                  <h6 className="fw_600">
                    Organización de congresos: planea, produce y ejecuta tu
                    evento con expertos
                  </h6>
                </Link>
                <Link
                  to={"/blog/4/marketing-y-diseno"}
                  className="item_picture"
                >
                  <img
                    src={bg02}
                    alt="Marketing y diseño: la fórmula creativa para posicionar tu
                      marca y generar resultado"
                  />
                  <h6 className="fw_600">
                    ¿Qué es el streaming y cómo puede ayudarte a conectar con tu
                    audiencia?
                  </h6>
                </Link>
                <Link
                  to={"/blog/5/organizacion-profesional-de-eventos"}
                  className="item_picture"
                >
                  <img
                    src={bg03}
                    alt=" Organización profesional de eventos: crea experiencias
                      memorables sin complicaciones"
                  />
                  <h6 className="fw_600">
                    Desarrollo de sistemas: transforma tus ideas en soluciones
                    digitales a la medida
                  </h6>
                </Link>
              </aside>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
